export const roleSteps = [
  {
    target: ".j_r_audit",
    content: "View the audit trail to track all actions and activity related to roles.",
    placement: "left",
  },
  {
    target: ".j_srch",
    content: "Quickly search roles by name, description, or other attributes.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content: "Apply filters to narrow down roles by dimension, type, or other properties.",
    placement: "bottom",
  },
  {
    target: ".j_r_create",
    content: "Click here to create a new role and assign it relevant access or permissions.",
    placement: "left",
  },
  {
    target: ".j_tbl1_col1",
    content: "This column is for selecting the roles to create  a security group.",
    placement: "top",
  },
  {
    target: ".j_tbl2_nam",
    content: "This column displays the role name for identification.",
    placement: "top",
  },
  {
    target: ".j_tbl3_des",
    content: "This column contains the role description to explain its purpose.",
    placement: "top",
  },
  {
    target: ".j_tbl4_dim",
    content: "This column shows the dimension or category each role belongs to.",
    placement: "top",
  },
  {
    target: ".j_tbl5_col5",
    content: "Here you can edit or delete roles using the respective action buttons.",
    placement: "left",
  },
];
